import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import username from "flarum/common/helpers/username";
// import userOnline from "flarum/common/helpers/userOnline";
import avatar from "flarum/common/helpers/avatar";
import Link from "flarum/common/components/Link";

export default class VotesCommentsModal extends Modal {
  className() {
    return 'VotesCommentsModal Modal--small';
  }

  title() {
    return app.translator.trans('fof-gamification.forum.modal.title');
  }

  oninit(vnode) {
    super.oninit(vnode);

    this.loading = !this.attrs.advcomment.upvotes() || !this.attrs.advcomment.downvotes();

    if (this.loading) {
      this.load();
    }
  }

  content() {
    if (this.loading) {
      return (
        <div className="Modal-body">
          <LoadingIndicator />
        </div>
      );
    }

    return (
      <div className="Modal-body">
        <ul className="VotesModal-list">
          {['upvotes', 'downvotes'].map((type) => {
            const voters = this.attrs.advcomment[type]();

            if (!voters || !voters.length) return;

            return (
              <div>
                <legend>{app.translator.trans(`fof-gamification.forum.modal.${type}_label`)}</legend>
                {voters.map((user) => (
                  <li>
                    <Link href={app.route.user(user)}>
                      {avatar(user)} {username(user)}
                    </Link>
                  </li>
                ))}
              </div>
            );
          })}
        </ul>
      </div>
    );
  }

  load() {
    return app.store
      .find('advcomments', this.attrs.advcomment.id(), {
        include: 'upvotes,downvotes',
      })
      .then(this.loaded.bind(this));
  }
}
